/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as Webhook_eventsRouteImport } from './routes/webhook_events'
import { Route as User_walletsRouteImport } from './routes/user_wallets'
import { Route as User_hotspotsRouteImport } from './routes/user_hotspots'
import { Route as SharesRouteImport } from './routes/shares'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReportingsRouteImport } from './routes/reportings'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as NeighborhoodRouteImport } from './routes/neighborhood'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ImprintRouteImport } from './routes/imprint'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as Dashboard_boxesRouteImport } from './routes/dashboard_boxes'
import { Route as CitiesRouteImport } from './routes/cities'
import { Route as ApiTokensRouteImport } from './routes/api-tokens'
import { Route as ApiRouteImport } from './routes/api'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WalletsIdRouteImport } from './routes/wallets.$id'
import { Route as HotspotsIdRouteImport } from './routes/hotspots.$id'
import { Route as CitiesIdRouteImport } from './routes/cities.$id'
import { Route as AuthTopSpotsRouteImport } from './routes/_auth.top-spots'
import { Route as AuthTagsRouteImport } from './routes/_auth.tags'
import { Route as AuthSupportRouteImport } from './routes/_auth.support'
import { Route as AuthSplitsRouteImport } from './routes/_auth.splits'
import { Route as AuthSpeedtestRouteImport } from './routes/_auth.speedtest'
import { Route as AuthSitesRouteImport } from './routes/_auth.sites'
import { Route as AuthSettlementsRouteImport } from './routes/_auth.settlements'
import { Route as AuthSettingsRouteImport } from './routes/_auth.settings'
import { Route as AuthPremiumRouteImport } from './routes/_auth.premium'
import { Route as AuthPlansRouteImport } from './routes/_auth.plans'
import { Route as AuthPayoutsRouteImport } from './routes/_auth.payouts'
import { Route as AuthPaymentsRouteImport } from './routes/_auth.payments'
import { Route as AuthNotificationsRouteImport } from './routes/_auth.notifications'
import { Route as AuthNotesRouteImport } from './routes/_auth.notes'
import { Route as AuthNewsRouteImport } from './routes/_auth.news'
import { Route as AuthMonthlyReportRouteImport } from './routes/_auth.monthly-report'
import { Route as AuthLegalRouteImport } from './routes/_auth.legal'
import { Route as AuthHotspotsRouteImport } from './routes/_auth.hotspots'
import { Route as AuthHelpRouteImport } from './routes/_auth.help'
import { Route as AuthEarnRateRouteImport } from './routes/_auth.earn-rate'
import { Route as AuthDashboardRouteImport } from './routes/_auth.dashboard'
import { Route as AuthCommissionsRouteImport } from './routes/_auth.commissions'
import { Route as AuthCheckoutRouteImport } from './routes/_auth.checkout'
import { Route as AuthApiDocsRouteImport } from './routes/_auth.api-docs'
import { Route as AuthAdminRouteImport } from './routes/_auth.admin'
import { Route as AuthActivitiesRouteImport } from './routes/_auth.activities'
import { Route as AuthAboutRouteImport } from './routes/_auth.about'
import { Route as AuthSplitsIndexRouteImport } from './routes/_auth.splits.index'
import { Route as AuthPeopleIndexRouteImport } from './routes/_auth.people.index'
import { Route as AuthLegalIndexRouteImport } from './routes/_auth.legal.index'
import { Route as AuthHotspotsIndexRouteImport } from './routes/_auth.hotspots.index'
import { Route as AuthHostsIndexRouteImport } from './routes/_auth.hosts.index'
import { Route as AuthDeveloperIndexRouteImport } from './routes/_auth.developer.index'
import { Route as AuthContactsIndexRouteImport } from './routes/_auth.contacts.index'
import { Route as AuthCommissionsIndexRouteImport } from './routes/_auth.commissions.index'
import { Route as AuthWalletsWatchedRouteImport } from './routes/_auth.wallets.watched'
import { Route as AuthTagsIdRouteImport } from './routes/_auth.tags.$id'
import { Route as AuthSplitsCreateRouteImport } from './routes/_auth.splits.create'
import { Route as AuthSplitsIdRouteImport } from './routes/_auth.splits.$id'
import { Route as AuthSitesIdRouteImport } from './routes/_auth.sites.$id'
import { Route as AuthSettlementsPayoutRouteImport } from './routes/_auth.settlements.payout'
import { Route as AuthPremiumSplatRouteImport } from './routes/_auth.premium_.$'
import { Route as AuthPeopleIdRouteImport } from './routes/_auth.people.$id'
import { Route as AuthLegalPrivacyRouteImport } from './routes/_auth.legal.privacy'
import { Route as AuthLegalImprintRouteImport } from './routes/_auth.legal.imprint'
import { Route as AuthHostsIdRouteImport } from './routes/_auth.hosts.$id'
import { Route as AuthDeveloperWebhooksRouteImport } from './routes/_auth.developer.webhooks'
import { Route as AuthDeveloperApiTokensRouteImport } from './routes/_auth.developer.api-tokens'
import { Route as AuthDashboardCustomizeRouteImport } from './routes/_auth.dashboard_.customize'
import { Route as AuthContactsIdRouteImport } from './routes/_auth.contacts.$id'
import { Route as AuthCommissionsCreateRouteImport } from './routes/_auth.commissions.create'
import { Route as AuthCommissionsIdRouteImport } from './routes/_auth.commissions.$id'
import { Route as AuthCheckoutSuccessRouteImport } from './routes/_auth.checkout_.success'
import { Route as AuthAdminUsersRouteImport } from './routes/_auth.admin.users'
import { Route as AuthAdminSupportTicketsRouteImport } from './routes/_auth.admin.support-tickets'
import { Route as AuthAdminRevenueRouteImport } from './routes/_auth.admin.revenue'
import { Route as AuthAdminNewslettersRouteImport } from './routes/_auth.admin.newsletters'
import { Route as AuthAccountSubscriptionRouteImport } from './routes/_auth.account.subscription'
import { Route as AuthDeveloperWebhooksWebhookIdDeliveriesRouteImport } from './routes/_auth.developer.webhooks.$webhookId.deliveries'

const MapLazyRouteImport = createFileRoute('/map')()
const AuthWalletsIndexLazyRouteImport = createFileRoute('/_auth/wallets/')()
const AuthHotspotsMapLazyRouteImport = createFileRoute('/_auth/hotspots/map')()

const MapLazyRoute = MapLazyRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/map.lazy').then((d) => d.Route))
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const Webhook_eventsRoute = Webhook_eventsRouteImport.update({
  id: '/webhook_events',
  path: '/webhook_events',
  getParentRoute: () => rootRouteImport,
} as any)
const User_walletsRoute = User_walletsRouteImport.update({
  id: '/user_wallets',
  path: '/user_wallets',
  getParentRoute: () => rootRouteImport,
} as any)
const User_hotspotsRoute = User_hotspotsRouteImport.update({
  id: '/user_hotspots',
  path: '/user_hotspots',
  getParentRoute: () => rootRouteImport,
} as any)
const SharesRoute = SharesRouteImport.update({
  id: '/shares',
  path: '/shares',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportingsRoute = ReportingsRouteImport.update({
  id: '/reportings',
  path: '/reportings',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const NeighborhoodRoute = NeighborhoodRouteImport.update({
  id: '/neighborhood',
  path: '/neighborhood',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ImprintRoute = ImprintRouteImport.update({
  id: '/imprint',
  path: '/imprint',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const Dashboard_boxesRoute = Dashboard_boxesRouteImport.update({
  id: '/dashboard_boxes',
  path: '/dashboard_boxes',
  getParentRoute: () => rootRouteImport,
} as any)
const CitiesRoute = CitiesRouteImport.update({
  id: '/cities',
  path: '/cities',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiTokensRoute = ApiTokensRouteImport.update({
  id: '/api-tokens',
  path: '/api-tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiRoute = ApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WalletsIdRoute = WalletsIdRouteImport.update({
  id: '/wallets/$id',
  path: '/wallets/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const HotspotsIdRoute = HotspotsIdRouteImport.update({
  id: '/hotspots/$id',
  path: '/hotspots/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CitiesIdRoute = CitiesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CitiesRoute,
} as any)
const AuthTopSpotsRoute = AuthTopSpotsRouteImport.update({
  id: '/top-spots',
  path: '/top-spots',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTagsRoute = AuthTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSupportRoute = AuthSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSplitsRoute = AuthSplitsRouteImport.update({
  id: '/splits',
  path: '/splits',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSpeedtestRoute = AuthSpeedtestRouteImport.update({
  id: '/speedtest',
  path: '/speedtest',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSitesRoute = AuthSitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettlementsRoute = AuthSettlementsRouteImport.update({
  id: '/settlements',
  path: '/settlements',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPremiumRoute = AuthPremiumRouteImport.update({
  id: '/premium',
  path: '/premium',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPlansRoute = AuthPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth.plans.lazy').then((d) => d.Route))
const AuthPayoutsRoute = AuthPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPaymentsRoute = AuthPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNotificationsRoute = AuthNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNotesRoute = AuthNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNewsRoute = AuthNewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMonthlyReportRoute = AuthMonthlyReportRouteImport.update({
  id: '/monthly-report',
  path: '/monthly-report',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLegalRoute = AuthLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHotspotsRoute = AuthHotspotsRouteImport.update({
  id: '/hotspots',
  path: '/hotspots',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHelpRoute = AuthHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEarnRateRoute = AuthEarnRateRouteImport.update({
  id: '/earn-rate',
  path: '/earn-rate',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth.dashboard.lazy').then((d) => d.Route),
)
const AuthCommissionsRoute = AuthCommissionsRouteImport.update({
  id: '/commissions',
  path: '/commissions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCheckoutRoute = AuthCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => AuthRoute,
} as any)
const AuthApiDocsRoute = AuthApiDocsRouteImport.update({
  id: '/api-docs',
  path: '/api-docs',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthActivitiesRoute = AuthActivitiesRouteImport.update({
  id: '/activities',
  path: '/activities',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAboutRoute = AuthAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWalletsIndexLazyRoute = AuthWalletsIndexLazyRouteImport.update({
  id: '/wallets/',
  path: '/wallets/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth.wallets.index.lazy').then((d) => d.Route),
)
const AuthSplitsIndexRoute = AuthSplitsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSplitsRoute,
} as any)
const AuthPeopleIndexRoute = AuthPeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLegalIndexRoute = AuthLegalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLegalRoute,
} as any)
const AuthHotspotsIndexRoute = AuthHotspotsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthHotspotsRoute,
} as any)
const AuthHostsIndexRoute = AuthHostsIndexRouteImport.update({
  id: '/hosts/',
  path: '/hosts/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDeveloperIndexRoute = AuthDeveloperIndexRouteImport.update({
  id: '/developer/',
  path: '/developer/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContactsIndexRoute = AuthContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCommissionsIndexRoute = AuthCommissionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthCommissionsRoute,
} as any)
const AuthHotspotsMapLazyRoute = AuthHotspotsMapLazyRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AuthHotspotsRoute,
} as any).lazy(() =>
  import('./routes/_auth.hotspots.map.lazy').then((d) => d.Route),
)
const AuthWalletsWatchedRoute = AuthWalletsWatchedRouteImport.update({
  id: '/wallets/watched',
  path: '/wallets/watched',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTagsIdRoute = AuthTagsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthTagsRoute,
} as any)
const AuthSplitsCreateRoute = AuthSplitsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthSplitsRoute,
} as any)
const AuthSplitsIdRoute = AuthSplitsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthSplitsRoute,
} as any)
const AuthSitesIdRoute = AuthSitesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthSitesRoute,
} as any)
const AuthSettlementsPayoutRoute = AuthSettlementsPayoutRouteImport.update({
  id: '/payout',
  path: '/payout',
  getParentRoute: () => AuthSettlementsRoute,
} as any)
const AuthPremiumSplatRoute = AuthPremiumSplatRouteImport.update({
  id: '/premium_/$',
  path: '/premium/$',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPeopleIdRoute = AuthPeopleIdRouteImport.update({
  id: '/people/$id',
  path: '/people/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLegalPrivacyRoute = AuthLegalPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AuthLegalRoute,
} as any)
const AuthLegalImprintRoute = AuthLegalImprintRouteImport.update({
  id: '/imprint',
  path: '/imprint',
  getParentRoute: () => AuthLegalRoute,
} as any)
const AuthHostsIdRoute = AuthHostsIdRouteImport.update({
  id: '/hosts/$id',
  path: '/hosts/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDeveloperWebhooksRoute = AuthDeveloperWebhooksRouteImport.update({
  id: '/developer/webhooks',
  path: '/developer/webhooks',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDeveloperApiTokensRoute = AuthDeveloperApiTokensRouteImport.update({
  id: '/developer/api-tokens',
  path: '/developer/api-tokens',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardCustomizeRoute = AuthDashboardCustomizeRouteImport.update({
  id: '/dashboard_/customize',
  path: '/dashboard/customize',
  getParentRoute: () => AuthRoute,
} as any)
const AuthContactsIdRoute = AuthContactsIdRouteImport.update({
  id: '/contacts/$id',
  path: '/contacts/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCommissionsCreateRoute = AuthCommissionsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthCommissionsRoute,
} as any)
const AuthCommissionsIdRoute = AuthCommissionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthCommissionsRoute,
} as any)
const AuthCheckoutSuccessRoute = AuthCheckoutSuccessRouteImport.update({
  id: '/checkout_/success',
  path: '/checkout/success',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminUsersRoute = AuthAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminSupportTicketsRoute = AuthAdminSupportTicketsRouteImport.update({
  id: '/support-tickets',
  path: '/support-tickets',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminRevenueRoute = AuthAdminRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminNewslettersRoute = AuthAdminNewslettersRouteImport.update({
  id: '/newsletters',
  path: '/newsletters',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAccountSubscriptionRoute = AuthAccountSubscriptionRouteImport.update({
  id: '/account/subscription',
  path: '/account/subscription',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDeveloperWebhooksWebhookIdDeliveriesRoute =
  AuthDeveloperWebhooksWebhookIdDeliveriesRouteImport.update({
    id: '/$webhookId/deliveries',
    path: '/$webhookId/deliveries',
    getParentRoute: () => AuthDeveloperWebhooksRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/api': typeof ApiRoute
  '/api-tokens': typeof ApiTokensRoute
  '/cities': typeof CitiesRouteWithChildren
  '/dashboard_boxes': typeof Dashboard_boxesRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/imprint': typeof ImprintRoute
  '/login': typeof LoginRoute
  '/neighborhood': typeof NeighborhoodRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reportings': typeof ReportingsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/shares': typeof SharesRoute
  '/user_hotspots': typeof User_hotspotsRoute
  '/user_wallets': typeof User_walletsRoute
  '/webhook_events': typeof Webhook_eventsRoute
  '/welcome': typeof WelcomeRoute
  '/map': typeof MapLazyRoute
  '/about': typeof AuthAboutRoute
  '/activities': typeof AuthActivitiesRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/api-docs': typeof AuthApiDocsRoute
  '/checkout': typeof AuthCheckoutRoute
  '/commissions': typeof AuthCommissionsRouteWithChildren
  '/dashboard': typeof AuthDashboardRoute
  '/earn-rate': typeof AuthEarnRateRoute
  '/help': typeof AuthHelpRoute
  '/hotspots': typeof AuthHotspotsRouteWithChildren
  '/legal': typeof AuthLegalRouteWithChildren
  '/monthly-report': typeof AuthMonthlyReportRoute
  '/news': typeof AuthNewsRoute
  '/notes': typeof AuthNotesRoute
  '/notifications': typeof AuthNotificationsRoute
  '/payments': typeof AuthPaymentsRoute
  '/payouts': typeof AuthPayoutsRoute
  '/plans': typeof AuthPlansRoute
  '/premium': typeof AuthPremiumRoute
  '/settings': typeof AuthSettingsRoute
  '/settlements': typeof AuthSettlementsRouteWithChildren
  '/sites': typeof AuthSitesRouteWithChildren
  '/speedtest': typeof AuthSpeedtestRoute
  '/splits': typeof AuthSplitsRouteWithChildren
  '/support': typeof AuthSupportRoute
  '/tags': typeof AuthTagsRouteWithChildren
  '/top-spots': typeof AuthTopSpotsRoute
  '/cities/$id': typeof CitiesIdRoute
  '/hotspots/$id': typeof HotspotsIdRoute
  '/wallets/$id': typeof WalletsIdRoute
  '/account/subscription': typeof AuthAccountSubscriptionRoute
  '/admin/newsletters': typeof AuthAdminNewslettersRoute
  '/admin/revenue': typeof AuthAdminRevenueRoute
  '/admin/support-tickets': typeof AuthAdminSupportTicketsRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/checkout/success': typeof AuthCheckoutSuccessRoute
  '/commissions/$id': typeof AuthCommissionsIdRoute
  '/commissions/create': typeof AuthCommissionsCreateRoute
  '/contacts/$id': typeof AuthContactsIdRoute
  '/dashboard/customize': typeof AuthDashboardCustomizeRoute
  '/developer/api-tokens': typeof AuthDeveloperApiTokensRoute
  '/developer/webhooks': typeof AuthDeveloperWebhooksRouteWithChildren
  '/hosts/$id': typeof AuthHostsIdRoute
  '/legal/imprint': typeof AuthLegalImprintRoute
  '/legal/privacy': typeof AuthLegalPrivacyRoute
  '/people/$id': typeof AuthPeopleIdRoute
  '/premium/$': typeof AuthPremiumSplatRoute
  '/settlements/payout': typeof AuthSettlementsPayoutRoute
  '/sites/$id': typeof AuthSitesIdRoute
  '/splits/$id': typeof AuthSplitsIdRoute
  '/splits/create': typeof AuthSplitsCreateRoute
  '/tags/$id': typeof AuthTagsIdRoute
  '/wallets/watched': typeof AuthWalletsWatchedRoute
  '/hotspots/map': typeof AuthHotspotsMapLazyRoute
  '/commissions/': typeof AuthCommissionsIndexRoute
  '/contacts/': typeof AuthContactsIndexRoute
  '/developer/': typeof AuthDeveloperIndexRoute
  '/hosts/': typeof AuthHostsIndexRoute
  '/hotspots/': typeof AuthHotspotsIndexRoute
  '/legal/': typeof AuthLegalIndexRoute
  '/people/': typeof AuthPeopleIndexRoute
  '/splits/': typeof AuthSplitsIndexRoute
  '/wallets/': typeof AuthWalletsIndexLazyRoute
  '/developer/webhooks/$webhookId/deliveries': typeof AuthDeveloperWebhooksWebhookIdDeliveriesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/api': typeof ApiRoute
  '/api-tokens': typeof ApiTokensRoute
  '/cities': typeof CitiesRouteWithChildren
  '/dashboard_boxes': typeof Dashboard_boxesRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/imprint': typeof ImprintRoute
  '/login': typeof LoginRoute
  '/neighborhood': typeof NeighborhoodRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reportings': typeof ReportingsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/shares': typeof SharesRoute
  '/user_hotspots': typeof User_hotspotsRoute
  '/user_wallets': typeof User_walletsRoute
  '/webhook_events': typeof Webhook_eventsRoute
  '/welcome': typeof WelcomeRoute
  '/map': typeof MapLazyRoute
  '/about': typeof AuthAboutRoute
  '/activities': typeof AuthActivitiesRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/api-docs': typeof AuthApiDocsRoute
  '/checkout': typeof AuthCheckoutRoute
  '/dashboard': typeof AuthDashboardRoute
  '/earn-rate': typeof AuthEarnRateRoute
  '/help': typeof AuthHelpRoute
  '/monthly-report': typeof AuthMonthlyReportRoute
  '/news': typeof AuthNewsRoute
  '/notes': typeof AuthNotesRoute
  '/notifications': typeof AuthNotificationsRoute
  '/payments': typeof AuthPaymentsRoute
  '/payouts': typeof AuthPayoutsRoute
  '/plans': typeof AuthPlansRoute
  '/premium': typeof AuthPremiumRoute
  '/settings': typeof AuthSettingsRoute
  '/settlements': typeof AuthSettlementsRouteWithChildren
  '/sites': typeof AuthSitesRouteWithChildren
  '/speedtest': typeof AuthSpeedtestRoute
  '/support': typeof AuthSupportRoute
  '/tags': typeof AuthTagsRouteWithChildren
  '/top-spots': typeof AuthTopSpotsRoute
  '/cities/$id': typeof CitiesIdRoute
  '/hotspots/$id': typeof HotspotsIdRoute
  '/wallets/$id': typeof WalletsIdRoute
  '/account/subscription': typeof AuthAccountSubscriptionRoute
  '/admin/newsletters': typeof AuthAdminNewslettersRoute
  '/admin/revenue': typeof AuthAdminRevenueRoute
  '/admin/support-tickets': typeof AuthAdminSupportTicketsRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/checkout/success': typeof AuthCheckoutSuccessRoute
  '/commissions/$id': typeof AuthCommissionsIdRoute
  '/commissions/create': typeof AuthCommissionsCreateRoute
  '/contacts/$id': typeof AuthContactsIdRoute
  '/dashboard/customize': typeof AuthDashboardCustomizeRoute
  '/developer/api-tokens': typeof AuthDeveloperApiTokensRoute
  '/developer/webhooks': typeof AuthDeveloperWebhooksRouteWithChildren
  '/hosts/$id': typeof AuthHostsIdRoute
  '/legal/imprint': typeof AuthLegalImprintRoute
  '/legal/privacy': typeof AuthLegalPrivacyRoute
  '/people/$id': typeof AuthPeopleIdRoute
  '/premium/$': typeof AuthPremiumSplatRoute
  '/settlements/payout': typeof AuthSettlementsPayoutRoute
  '/sites/$id': typeof AuthSitesIdRoute
  '/splits/$id': typeof AuthSplitsIdRoute
  '/splits/create': typeof AuthSplitsCreateRoute
  '/tags/$id': typeof AuthTagsIdRoute
  '/wallets/watched': typeof AuthWalletsWatchedRoute
  '/hotspots/map': typeof AuthHotspotsMapLazyRoute
  '/commissions': typeof AuthCommissionsIndexRoute
  '/contacts': typeof AuthContactsIndexRoute
  '/developer': typeof AuthDeveloperIndexRoute
  '/hosts': typeof AuthHostsIndexRoute
  '/hotspots': typeof AuthHotspotsIndexRoute
  '/legal': typeof AuthLegalIndexRoute
  '/people': typeof AuthPeopleIndexRoute
  '/splits': typeof AuthSplitsIndexRoute
  '/wallets': typeof AuthWalletsIndexLazyRoute
  '/developer/webhooks/$webhookId/deliveries': typeof AuthDeveloperWebhooksWebhookIdDeliveriesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/account': typeof AccountRoute
  '/api': typeof ApiRoute
  '/api-tokens': typeof ApiTokensRoute
  '/cities': typeof CitiesRouteWithChildren
  '/dashboard_boxes': typeof Dashboard_boxesRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/imprint': typeof ImprintRoute
  '/login': typeof LoginRoute
  '/neighborhood': typeof NeighborhoodRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reportings': typeof ReportingsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/shares': typeof SharesRoute
  '/user_hotspots': typeof User_hotspotsRoute
  '/user_wallets': typeof User_walletsRoute
  '/webhook_events': typeof Webhook_eventsRoute
  '/welcome': typeof WelcomeRoute
  '/map': typeof MapLazyRoute
  '/_auth/about': typeof AuthAboutRoute
  '/_auth/activities': typeof AuthActivitiesRoute
  '/_auth/admin': typeof AuthAdminRouteWithChildren
  '/_auth/api-docs': typeof AuthApiDocsRoute
  '/_auth/checkout': typeof AuthCheckoutRoute
  '/_auth/commissions': typeof AuthCommissionsRouteWithChildren
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/earn-rate': typeof AuthEarnRateRoute
  '/_auth/help': typeof AuthHelpRoute
  '/_auth/hotspots': typeof AuthHotspotsRouteWithChildren
  '/_auth/legal': typeof AuthLegalRouteWithChildren
  '/_auth/monthly-report': typeof AuthMonthlyReportRoute
  '/_auth/news': typeof AuthNewsRoute
  '/_auth/notes': typeof AuthNotesRoute
  '/_auth/notifications': typeof AuthNotificationsRoute
  '/_auth/payments': typeof AuthPaymentsRoute
  '/_auth/payouts': typeof AuthPayoutsRoute
  '/_auth/plans': typeof AuthPlansRoute
  '/_auth/premium': typeof AuthPremiumRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/settlements': typeof AuthSettlementsRouteWithChildren
  '/_auth/sites': typeof AuthSitesRouteWithChildren
  '/_auth/speedtest': typeof AuthSpeedtestRoute
  '/_auth/splits': typeof AuthSplitsRouteWithChildren
  '/_auth/support': typeof AuthSupportRoute
  '/_auth/tags': typeof AuthTagsRouteWithChildren
  '/_auth/top-spots': typeof AuthTopSpotsRoute
  '/cities/$id': typeof CitiesIdRoute
  '/hotspots/$id': typeof HotspotsIdRoute
  '/wallets/$id': typeof WalletsIdRoute
  '/_auth/account/subscription': typeof AuthAccountSubscriptionRoute
  '/_auth/admin/newsletters': typeof AuthAdminNewslettersRoute
  '/_auth/admin/revenue': typeof AuthAdminRevenueRoute
  '/_auth/admin/support-tickets': typeof AuthAdminSupportTicketsRoute
  '/_auth/admin/users': typeof AuthAdminUsersRoute
  '/_auth/checkout_/success': typeof AuthCheckoutSuccessRoute
  '/_auth/commissions/$id': typeof AuthCommissionsIdRoute
  '/_auth/commissions/create': typeof AuthCommissionsCreateRoute
  '/_auth/contacts/$id': typeof AuthContactsIdRoute
  '/_auth/dashboard_/customize': typeof AuthDashboardCustomizeRoute
  '/_auth/developer/api-tokens': typeof AuthDeveloperApiTokensRoute
  '/_auth/developer/webhooks': typeof AuthDeveloperWebhooksRouteWithChildren
  '/_auth/hosts/$id': typeof AuthHostsIdRoute
  '/_auth/legal/imprint': typeof AuthLegalImprintRoute
  '/_auth/legal/privacy': typeof AuthLegalPrivacyRoute
  '/_auth/people/$id': typeof AuthPeopleIdRoute
  '/_auth/premium_/$': typeof AuthPremiumSplatRoute
  '/_auth/settlements/payout': typeof AuthSettlementsPayoutRoute
  '/_auth/sites/$id': typeof AuthSitesIdRoute
  '/_auth/splits/$id': typeof AuthSplitsIdRoute
  '/_auth/splits/create': typeof AuthSplitsCreateRoute
  '/_auth/tags/$id': typeof AuthTagsIdRoute
  '/_auth/wallets/watched': typeof AuthWalletsWatchedRoute
  '/_auth/hotspots/map': typeof AuthHotspotsMapLazyRoute
  '/_auth/commissions/': typeof AuthCommissionsIndexRoute
  '/_auth/contacts/': typeof AuthContactsIndexRoute
  '/_auth/developer/': typeof AuthDeveloperIndexRoute
  '/_auth/hosts/': typeof AuthHostsIndexRoute
  '/_auth/hotspots/': typeof AuthHotspotsIndexRoute
  '/_auth/legal/': typeof AuthLegalIndexRoute
  '/_auth/people/': typeof AuthPeopleIndexRoute
  '/_auth/splits/': typeof AuthSplitsIndexRoute
  '/_auth/wallets/': typeof AuthWalletsIndexLazyRoute
  '/_auth/developer/webhooks/$webhookId/deliveries': typeof AuthDeveloperWebhooksWebhookIdDeliveriesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/api'
    | '/api-tokens'
    | '/cities'
    | '/dashboard_boxes'
    | '/forgot-password'
    | '/imprint'
    | '/login'
    | '/neighborhood'
    | '/privacy'
    | '/register'
    | '/reportings'
    | '/reset-password'
    | '/shares'
    | '/user_hotspots'
    | '/user_wallets'
    | '/webhook_events'
    | '/welcome'
    | '/map'
    | '/about'
    | '/activities'
    | '/admin'
    | '/api-docs'
    | '/checkout'
    | '/commissions'
    | '/dashboard'
    | '/earn-rate'
    | '/help'
    | '/hotspots'
    | '/legal'
    | '/monthly-report'
    | '/news'
    | '/notes'
    | '/notifications'
    | '/payments'
    | '/payouts'
    | '/plans'
    | '/premium'
    | '/settings'
    | '/settlements'
    | '/sites'
    | '/speedtest'
    | '/splits'
    | '/support'
    | '/tags'
    | '/top-spots'
    | '/cities/$id'
    | '/hotspots/$id'
    | '/wallets/$id'
    | '/account/subscription'
    | '/admin/newsletters'
    | '/admin/revenue'
    | '/admin/support-tickets'
    | '/admin/users'
    | '/checkout/success'
    | '/commissions/$id'
    | '/commissions/create'
    | '/contacts/$id'
    | '/dashboard/customize'
    | '/developer/api-tokens'
    | '/developer/webhooks'
    | '/hosts/$id'
    | '/legal/imprint'
    | '/legal/privacy'
    | '/people/$id'
    | '/premium/$'
    | '/settlements/payout'
    | '/sites/$id'
    | '/splits/$id'
    | '/splits/create'
    | '/tags/$id'
    | '/wallets/watched'
    | '/hotspots/map'
    | '/commissions/'
    | '/contacts/'
    | '/developer/'
    | '/hosts/'
    | '/hotspots/'
    | '/legal/'
    | '/people/'
    | '/splits/'
    | '/wallets/'
    | '/developer/webhooks/$webhookId/deliveries'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/api'
    | '/api-tokens'
    | '/cities'
    | '/dashboard_boxes'
    | '/forgot-password'
    | '/imprint'
    | '/login'
    | '/neighborhood'
    | '/privacy'
    | '/register'
    | '/reportings'
    | '/reset-password'
    | '/shares'
    | '/user_hotspots'
    | '/user_wallets'
    | '/webhook_events'
    | '/welcome'
    | '/map'
    | '/about'
    | '/activities'
    | '/admin'
    | '/api-docs'
    | '/checkout'
    | '/dashboard'
    | '/earn-rate'
    | '/help'
    | '/monthly-report'
    | '/news'
    | '/notes'
    | '/notifications'
    | '/payments'
    | '/payouts'
    | '/plans'
    | '/premium'
    | '/settings'
    | '/settlements'
    | '/sites'
    | '/speedtest'
    | '/support'
    | '/tags'
    | '/top-spots'
    | '/cities/$id'
    | '/hotspots/$id'
    | '/wallets/$id'
    | '/account/subscription'
    | '/admin/newsletters'
    | '/admin/revenue'
    | '/admin/support-tickets'
    | '/admin/users'
    | '/checkout/success'
    | '/commissions/$id'
    | '/commissions/create'
    | '/contacts/$id'
    | '/dashboard/customize'
    | '/developer/api-tokens'
    | '/developer/webhooks'
    | '/hosts/$id'
    | '/legal/imprint'
    | '/legal/privacy'
    | '/people/$id'
    | '/premium/$'
    | '/settlements/payout'
    | '/sites/$id'
    | '/splits/$id'
    | '/splits/create'
    | '/tags/$id'
    | '/wallets/watched'
    | '/hotspots/map'
    | '/commissions'
    | '/contacts'
    | '/developer'
    | '/hosts'
    | '/hotspots'
    | '/legal'
    | '/people'
    | '/splits'
    | '/wallets'
    | '/developer/webhooks/$webhookId/deliveries'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/account'
    | '/api'
    | '/api-tokens'
    | '/cities'
    | '/dashboard_boxes'
    | '/forgot-password'
    | '/imprint'
    | '/login'
    | '/neighborhood'
    | '/privacy'
    | '/register'
    | '/reportings'
    | '/reset-password'
    | '/shares'
    | '/user_hotspots'
    | '/user_wallets'
    | '/webhook_events'
    | '/welcome'
    | '/map'
    | '/_auth/about'
    | '/_auth/activities'
    | '/_auth/admin'
    | '/_auth/api-docs'
    | '/_auth/checkout'
    | '/_auth/commissions'
    | '/_auth/dashboard'
    | '/_auth/earn-rate'
    | '/_auth/help'
    | '/_auth/hotspots'
    | '/_auth/legal'
    | '/_auth/monthly-report'
    | '/_auth/news'
    | '/_auth/notes'
    | '/_auth/notifications'
    | '/_auth/payments'
    | '/_auth/payouts'
    | '/_auth/plans'
    | '/_auth/premium'
    | '/_auth/settings'
    | '/_auth/settlements'
    | '/_auth/sites'
    | '/_auth/speedtest'
    | '/_auth/splits'
    | '/_auth/support'
    | '/_auth/tags'
    | '/_auth/top-spots'
    | '/cities/$id'
    | '/hotspots/$id'
    | '/wallets/$id'
    | '/_auth/account/subscription'
    | '/_auth/admin/newsletters'
    | '/_auth/admin/revenue'
    | '/_auth/admin/support-tickets'
    | '/_auth/admin/users'
    | '/_auth/checkout_/success'
    | '/_auth/commissions/$id'
    | '/_auth/commissions/create'
    | '/_auth/contacts/$id'
    | '/_auth/dashboard_/customize'
    | '/_auth/developer/api-tokens'
    | '/_auth/developer/webhooks'
    | '/_auth/hosts/$id'
    | '/_auth/legal/imprint'
    | '/_auth/legal/privacy'
    | '/_auth/people/$id'
    | '/_auth/premium_/$'
    | '/_auth/settlements/payout'
    | '/_auth/sites/$id'
    | '/_auth/splits/$id'
    | '/_auth/splits/create'
    | '/_auth/tags/$id'
    | '/_auth/wallets/watched'
    | '/_auth/hotspots/map'
    | '/_auth/commissions/'
    | '/_auth/contacts/'
    | '/_auth/developer/'
    | '/_auth/hosts/'
    | '/_auth/hotspots/'
    | '/_auth/legal/'
    | '/_auth/people/'
    | '/_auth/splits/'
    | '/_auth/wallets/'
    | '/_auth/developer/webhooks/$webhookId/deliveries'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AccountRoute: typeof AccountRoute
  ApiRoute: typeof ApiRoute
  ApiTokensRoute: typeof ApiTokensRoute
  CitiesRoute: typeof CitiesRouteWithChildren
  Dashboard_boxesRoute: typeof Dashboard_boxesRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ImprintRoute: typeof ImprintRoute
  LoginRoute: typeof LoginRoute
  NeighborhoodRoute: typeof NeighborhoodRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  ReportingsRoute: typeof ReportingsRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SharesRoute: typeof SharesRoute
  User_hotspotsRoute: typeof User_hotspotsRoute
  User_walletsRoute: typeof User_walletsRoute
  Webhook_eventsRoute: typeof Webhook_eventsRoute
  WelcomeRoute: typeof WelcomeRoute
  MapLazyRoute: typeof MapLazyRoute
  HotspotsIdRoute: typeof HotspotsIdRoute
  WalletsIdRoute: typeof WalletsIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/map': {
      id: '/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webhook_events': {
      id: '/webhook_events'
      path: '/webhook_events'
      fullPath: '/webhook_events'
      preLoaderRoute: typeof Webhook_eventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user_wallets': {
      id: '/user_wallets'
      path: '/user_wallets'
      fullPath: '/user_wallets'
      preLoaderRoute: typeof User_walletsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user_hotspots': {
      id: '/user_hotspots'
      path: '/user_hotspots'
      fullPath: '/user_hotspots'
      preLoaderRoute: typeof User_hotspotsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shares': {
      id: '/shares'
      path: '/shares'
      fullPath: '/shares'
      preLoaderRoute: typeof SharesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reportings': {
      id: '/reportings'
      path: '/reportings'
      fullPath: '/reportings'
      preLoaderRoute: typeof ReportingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/neighborhood': {
      id: '/neighborhood'
      path: '/neighborhood'
      fullPath: '/neighborhood'
      preLoaderRoute: typeof NeighborhoodRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imprint': {
      id: '/imprint'
      path: '/imprint'
      fullPath: '/imprint'
      preLoaderRoute: typeof ImprintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard_boxes': {
      id: '/dashboard_boxes'
      path: '/dashboard_boxes'
      fullPath: '/dashboard_boxes'
      preLoaderRoute: typeof Dashboard_boxesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cities': {
      id: '/cities'
      path: '/cities'
      fullPath: '/cities'
      preLoaderRoute: typeof CitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-tokens': {
      id: '/api-tokens'
      path: '/api-tokens'
      fullPath: '/api-tokens'
      preLoaderRoute: typeof ApiTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api': {
      id: '/api'
      path: '/api'
      fullPath: '/api'
      preLoaderRoute: typeof ApiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wallets/$id': {
      id: '/wallets/$id'
      path: '/wallets/$id'
      fullPath: '/wallets/$id'
      preLoaderRoute: typeof WalletsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hotspots/$id': {
      id: '/hotspots/$id'
      path: '/hotspots/$id'
      fullPath: '/hotspots/$id'
      preLoaderRoute: typeof HotspotsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cities/$id': {
      id: '/cities/$id'
      path: '/$id'
      fullPath: '/cities/$id'
      preLoaderRoute: typeof CitiesIdRouteImport
      parentRoute: typeof CitiesRoute
    }
    '/_auth/top-spots': {
      id: '/_auth/top-spots'
      path: '/top-spots'
      fullPath: '/top-spots'
      preLoaderRoute: typeof AuthTopSpotsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tags': {
      id: '/_auth/tags'
      path: '/tags'
      fullPath: '/tags'
      preLoaderRoute: typeof AuthTagsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/support': {
      id: '/_auth/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthSupportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/splits': {
      id: '/_auth/splits'
      path: '/splits'
      fullPath: '/splits'
      preLoaderRoute: typeof AuthSplitsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/speedtest': {
      id: '/_auth/speedtest'
      path: '/speedtest'
      fullPath: '/speedtest'
      preLoaderRoute: typeof AuthSpeedtestRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sites': {
      id: '/_auth/sites'
      path: '/sites'
      fullPath: '/sites'
      preLoaderRoute: typeof AuthSitesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settlements': {
      id: '/_auth/settlements'
      path: '/settlements'
      fullPath: '/settlements'
      preLoaderRoute: typeof AuthSettlementsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/premium': {
      id: '/_auth/premium'
      path: '/premium'
      fullPath: '/premium'
      preLoaderRoute: typeof AuthPremiumRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/plans': {
      id: '/_auth/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof AuthPlansRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payouts': {
      id: '/_auth/payouts'
      path: '/payouts'
      fullPath: '/payouts'
      preLoaderRoute: typeof AuthPayoutsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payments': {
      id: '/_auth/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AuthPaymentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/notifications': {
      id: '/_auth/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthNotificationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/notes': {
      id: '/_auth/notes'
      path: '/notes'
      fullPath: '/notes'
      preLoaderRoute: typeof AuthNotesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/news': {
      id: '/_auth/news'
      path: '/news'
      fullPath: '/news'
      preLoaderRoute: typeof AuthNewsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/monthly-report': {
      id: '/_auth/monthly-report'
      path: '/monthly-report'
      fullPath: '/monthly-report'
      preLoaderRoute: typeof AuthMonthlyReportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/legal': {
      id: '/_auth/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof AuthLegalRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/hotspots': {
      id: '/_auth/hotspots'
      path: '/hotspots'
      fullPath: '/hotspots'
      preLoaderRoute: typeof AuthHotspotsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/help': {
      id: '/_auth/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AuthHelpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/earn-rate': {
      id: '/_auth/earn-rate'
      path: '/earn-rate'
      fullPath: '/earn-rate'
      preLoaderRoute: typeof AuthEarnRateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/commissions': {
      id: '/_auth/commissions'
      path: '/commissions'
      fullPath: '/commissions'
      preLoaderRoute: typeof AuthCommissionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/checkout': {
      id: '/_auth/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof AuthCheckoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/api-docs': {
      id: '/_auth/api-docs'
      path: '/api-docs'
      fullPath: '/api-docs'
      preLoaderRoute: typeof AuthApiDocsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/activities': {
      id: '/_auth/activities'
      path: '/activities'
      fullPath: '/activities'
      preLoaderRoute: typeof AuthActivitiesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/about': {
      id: '/_auth/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AuthAboutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/wallets/': {
      id: '/_auth/wallets/'
      path: '/wallets'
      fullPath: '/wallets/'
      preLoaderRoute: typeof AuthWalletsIndexLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/splits/': {
      id: '/_auth/splits/'
      path: '/'
      fullPath: '/splits/'
      preLoaderRoute: typeof AuthSplitsIndexRouteImport
      parentRoute: typeof AuthSplitsRoute
    }
    '/_auth/people/': {
      id: '/_auth/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof AuthPeopleIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/legal/': {
      id: '/_auth/legal/'
      path: '/'
      fullPath: '/legal/'
      preLoaderRoute: typeof AuthLegalIndexRouteImport
      parentRoute: typeof AuthLegalRoute
    }
    '/_auth/hotspots/': {
      id: '/_auth/hotspots/'
      path: '/'
      fullPath: '/hotspots/'
      preLoaderRoute: typeof AuthHotspotsIndexRouteImport
      parentRoute: typeof AuthHotspotsRoute
    }
    '/_auth/hosts/': {
      id: '/_auth/hosts/'
      path: '/hosts'
      fullPath: '/hosts/'
      preLoaderRoute: typeof AuthHostsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/developer/': {
      id: '/_auth/developer/'
      path: '/developer'
      fullPath: '/developer/'
      preLoaderRoute: typeof AuthDeveloperIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contacts/': {
      id: '/_auth/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AuthContactsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/commissions/': {
      id: '/_auth/commissions/'
      path: '/'
      fullPath: '/commissions/'
      preLoaderRoute: typeof AuthCommissionsIndexRouteImport
      parentRoute: typeof AuthCommissionsRoute
    }
    '/_auth/hotspots/map': {
      id: '/_auth/hotspots/map'
      path: '/map'
      fullPath: '/hotspots/map'
      preLoaderRoute: typeof AuthHotspotsMapLazyRouteImport
      parentRoute: typeof AuthHotspotsRoute
    }
    '/_auth/wallets/watched': {
      id: '/_auth/wallets/watched'
      path: '/wallets/watched'
      fullPath: '/wallets/watched'
      preLoaderRoute: typeof AuthWalletsWatchedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tags/$id': {
      id: '/_auth/tags/$id'
      path: '/$id'
      fullPath: '/tags/$id'
      preLoaderRoute: typeof AuthTagsIdRouteImport
      parentRoute: typeof AuthTagsRoute
    }
    '/_auth/splits/create': {
      id: '/_auth/splits/create'
      path: '/create'
      fullPath: '/splits/create'
      preLoaderRoute: typeof AuthSplitsCreateRouteImport
      parentRoute: typeof AuthSplitsRoute
    }
    '/_auth/splits/$id': {
      id: '/_auth/splits/$id'
      path: '/$id'
      fullPath: '/splits/$id'
      preLoaderRoute: typeof AuthSplitsIdRouteImport
      parentRoute: typeof AuthSplitsRoute
    }
    '/_auth/sites/$id': {
      id: '/_auth/sites/$id'
      path: '/$id'
      fullPath: '/sites/$id'
      preLoaderRoute: typeof AuthSitesIdRouteImport
      parentRoute: typeof AuthSitesRoute
    }
    '/_auth/settlements/payout': {
      id: '/_auth/settlements/payout'
      path: '/payout'
      fullPath: '/settlements/payout'
      preLoaderRoute: typeof AuthSettlementsPayoutRouteImport
      parentRoute: typeof AuthSettlementsRoute
    }
    '/_auth/premium_/$': {
      id: '/_auth/premium_/$'
      path: '/premium/$'
      fullPath: '/premium/$'
      preLoaderRoute: typeof AuthPremiumSplatRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/people/$id': {
      id: '/_auth/people/$id'
      path: '/people/$id'
      fullPath: '/people/$id'
      preLoaderRoute: typeof AuthPeopleIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/legal/privacy': {
      id: '/_auth/legal/privacy'
      path: '/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof AuthLegalPrivacyRouteImport
      parentRoute: typeof AuthLegalRoute
    }
    '/_auth/legal/imprint': {
      id: '/_auth/legal/imprint'
      path: '/imprint'
      fullPath: '/legal/imprint'
      preLoaderRoute: typeof AuthLegalImprintRouteImport
      parentRoute: typeof AuthLegalRoute
    }
    '/_auth/hosts/$id': {
      id: '/_auth/hosts/$id'
      path: '/hosts/$id'
      fullPath: '/hosts/$id'
      preLoaderRoute: typeof AuthHostsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/developer/webhooks': {
      id: '/_auth/developer/webhooks'
      path: '/developer/webhooks'
      fullPath: '/developer/webhooks'
      preLoaderRoute: typeof AuthDeveloperWebhooksRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/developer/api-tokens': {
      id: '/_auth/developer/api-tokens'
      path: '/developer/api-tokens'
      fullPath: '/developer/api-tokens'
      preLoaderRoute: typeof AuthDeveloperApiTokensRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard_/customize': {
      id: '/_auth/dashboard_/customize'
      path: '/dashboard/customize'
      fullPath: '/dashboard/customize'
      preLoaderRoute: typeof AuthDashboardCustomizeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/contacts/$id': {
      id: '/_auth/contacts/$id'
      path: '/contacts/$id'
      fullPath: '/contacts/$id'
      preLoaderRoute: typeof AuthContactsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/commissions/create': {
      id: '/_auth/commissions/create'
      path: '/create'
      fullPath: '/commissions/create'
      preLoaderRoute: typeof AuthCommissionsCreateRouteImport
      parentRoute: typeof AuthCommissionsRoute
    }
    '/_auth/commissions/$id': {
      id: '/_auth/commissions/$id'
      path: '/$id'
      fullPath: '/commissions/$id'
      preLoaderRoute: typeof AuthCommissionsIdRouteImport
      parentRoute: typeof AuthCommissionsRoute
    }
    '/_auth/checkout_/success': {
      id: '/_auth/checkout_/success'
      path: '/checkout/success'
      fullPath: '/checkout/success'
      preLoaderRoute: typeof AuthCheckoutSuccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/users': {
      id: '/_auth/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthAdminUsersRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/support-tickets': {
      id: '/_auth/admin/support-tickets'
      path: '/support-tickets'
      fullPath: '/admin/support-tickets'
      preLoaderRoute: typeof AuthAdminSupportTicketsRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/revenue': {
      id: '/_auth/admin/revenue'
      path: '/revenue'
      fullPath: '/admin/revenue'
      preLoaderRoute: typeof AuthAdminRevenueRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/admin/newsletters': {
      id: '/_auth/admin/newsletters'
      path: '/newsletters'
      fullPath: '/admin/newsletters'
      preLoaderRoute: typeof AuthAdminNewslettersRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/account/subscription': {
      id: '/_auth/account/subscription'
      path: '/account/subscription'
      fullPath: '/account/subscription'
      preLoaderRoute: typeof AuthAccountSubscriptionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/developer/webhooks/$webhookId/deliveries': {
      id: '/_auth/developer/webhooks/$webhookId/deliveries'
      path: '/$webhookId/deliveries'
      fullPath: '/developer/webhooks/$webhookId/deliveries'
      preLoaderRoute: typeof AuthDeveloperWebhooksWebhookIdDeliveriesRouteImport
      parentRoute: typeof AuthDeveloperWebhooksRoute
    }
  }
}

interface AuthAdminRouteChildren {
  AuthAdminNewslettersRoute: typeof AuthAdminNewslettersRoute
  AuthAdminRevenueRoute: typeof AuthAdminRevenueRoute
  AuthAdminSupportTicketsRoute: typeof AuthAdminSupportTicketsRoute
  AuthAdminUsersRoute: typeof AuthAdminUsersRoute
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminNewslettersRoute: AuthAdminNewslettersRoute,
  AuthAdminRevenueRoute: AuthAdminRevenueRoute,
  AuthAdminSupportTicketsRoute: AuthAdminSupportTicketsRoute,
  AuthAdminUsersRoute: AuthAdminUsersRoute,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthCommissionsRouteChildren {
  AuthCommissionsIdRoute: typeof AuthCommissionsIdRoute
  AuthCommissionsCreateRoute: typeof AuthCommissionsCreateRoute
  AuthCommissionsIndexRoute: typeof AuthCommissionsIndexRoute
}

const AuthCommissionsRouteChildren: AuthCommissionsRouteChildren = {
  AuthCommissionsIdRoute: AuthCommissionsIdRoute,
  AuthCommissionsCreateRoute: AuthCommissionsCreateRoute,
  AuthCommissionsIndexRoute: AuthCommissionsIndexRoute,
}

const AuthCommissionsRouteWithChildren = AuthCommissionsRoute._addFileChildren(
  AuthCommissionsRouteChildren,
)

interface AuthHotspotsRouteChildren {
  AuthHotspotsMapLazyRoute: typeof AuthHotspotsMapLazyRoute
  AuthHotspotsIndexRoute: typeof AuthHotspotsIndexRoute
}

const AuthHotspotsRouteChildren: AuthHotspotsRouteChildren = {
  AuthHotspotsMapLazyRoute: AuthHotspotsMapLazyRoute,
  AuthHotspotsIndexRoute: AuthHotspotsIndexRoute,
}

const AuthHotspotsRouteWithChildren = AuthHotspotsRoute._addFileChildren(
  AuthHotspotsRouteChildren,
)

interface AuthLegalRouteChildren {
  AuthLegalImprintRoute: typeof AuthLegalImprintRoute
  AuthLegalPrivacyRoute: typeof AuthLegalPrivacyRoute
  AuthLegalIndexRoute: typeof AuthLegalIndexRoute
}

const AuthLegalRouteChildren: AuthLegalRouteChildren = {
  AuthLegalImprintRoute: AuthLegalImprintRoute,
  AuthLegalPrivacyRoute: AuthLegalPrivacyRoute,
  AuthLegalIndexRoute: AuthLegalIndexRoute,
}

const AuthLegalRouteWithChildren = AuthLegalRoute._addFileChildren(
  AuthLegalRouteChildren,
)

interface AuthSettlementsRouteChildren {
  AuthSettlementsPayoutRoute: typeof AuthSettlementsPayoutRoute
}

const AuthSettlementsRouteChildren: AuthSettlementsRouteChildren = {
  AuthSettlementsPayoutRoute: AuthSettlementsPayoutRoute,
}

const AuthSettlementsRouteWithChildren = AuthSettlementsRoute._addFileChildren(
  AuthSettlementsRouteChildren,
)

interface AuthSitesRouteChildren {
  AuthSitesIdRoute: typeof AuthSitesIdRoute
}

const AuthSitesRouteChildren: AuthSitesRouteChildren = {
  AuthSitesIdRoute: AuthSitesIdRoute,
}

const AuthSitesRouteWithChildren = AuthSitesRoute._addFileChildren(
  AuthSitesRouteChildren,
)

interface AuthSplitsRouteChildren {
  AuthSplitsIdRoute: typeof AuthSplitsIdRoute
  AuthSplitsCreateRoute: typeof AuthSplitsCreateRoute
  AuthSplitsIndexRoute: typeof AuthSplitsIndexRoute
}

const AuthSplitsRouteChildren: AuthSplitsRouteChildren = {
  AuthSplitsIdRoute: AuthSplitsIdRoute,
  AuthSplitsCreateRoute: AuthSplitsCreateRoute,
  AuthSplitsIndexRoute: AuthSplitsIndexRoute,
}

const AuthSplitsRouteWithChildren = AuthSplitsRoute._addFileChildren(
  AuthSplitsRouteChildren,
)

interface AuthTagsRouteChildren {
  AuthTagsIdRoute: typeof AuthTagsIdRoute
}

const AuthTagsRouteChildren: AuthTagsRouteChildren = {
  AuthTagsIdRoute: AuthTagsIdRoute,
}

const AuthTagsRouteWithChildren = AuthTagsRoute._addFileChildren(
  AuthTagsRouteChildren,
)

interface AuthDeveloperWebhooksRouteChildren {
  AuthDeveloperWebhooksWebhookIdDeliveriesRoute: typeof AuthDeveloperWebhooksWebhookIdDeliveriesRoute
}

const AuthDeveloperWebhooksRouteChildren: AuthDeveloperWebhooksRouteChildren = {
  AuthDeveloperWebhooksWebhookIdDeliveriesRoute:
    AuthDeveloperWebhooksWebhookIdDeliveriesRoute,
}

const AuthDeveloperWebhooksRouteWithChildren =
  AuthDeveloperWebhooksRoute._addFileChildren(
    AuthDeveloperWebhooksRouteChildren,
  )

interface AuthRouteChildren {
  AuthAboutRoute: typeof AuthAboutRoute
  AuthActivitiesRoute: typeof AuthActivitiesRoute
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthApiDocsRoute: typeof AuthApiDocsRoute
  AuthCheckoutRoute: typeof AuthCheckoutRoute
  AuthCommissionsRoute: typeof AuthCommissionsRouteWithChildren
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthEarnRateRoute: typeof AuthEarnRateRoute
  AuthHelpRoute: typeof AuthHelpRoute
  AuthHotspotsRoute: typeof AuthHotspotsRouteWithChildren
  AuthLegalRoute: typeof AuthLegalRouteWithChildren
  AuthMonthlyReportRoute: typeof AuthMonthlyReportRoute
  AuthNewsRoute: typeof AuthNewsRoute
  AuthNotesRoute: typeof AuthNotesRoute
  AuthNotificationsRoute: typeof AuthNotificationsRoute
  AuthPaymentsRoute: typeof AuthPaymentsRoute
  AuthPayoutsRoute: typeof AuthPayoutsRoute
  AuthPlansRoute: typeof AuthPlansRoute
  AuthPremiumRoute: typeof AuthPremiumRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthSettlementsRoute: typeof AuthSettlementsRouteWithChildren
  AuthSitesRoute: typeof AuthSitesRouteWithChildren
  AuthSpeedtestRoute: typeof AuthSpeedtestRoute
  AuthSplitsRoute: typeof AuthSplitsRouteWithChildren
  AuthSupportRoute: typeof AuthSupportRoute
  AuthTagsRoute: typeof AuthTagsRouteWithChildren
  AuthTopSpotsRoute: typeof AuthTopSpotsRoute
  AuthAccountSubscriptionRoute: typeof AuthAccountSubscriptionRoute
  AuthCheckoutSuccessRoute: typeof AuthCheckoutSuccessRoute
  AuthContactsIdRoute: typeof AuthContactsIdRoute
  AuthDashboardCustomizeRoute: typeof AuthDashboardCustomizeRoute
  AuthDeveloperApiTokensRoute: typeof AuthDeveloperApiTokensRoute
  AuthDeveloperWebhooksRoute: typeof AuthDeveloperWebhooksRouteWithChildren
  AuthHostsIdRoute: typeof AuthHostsIdRoute
  AuthPeopleIdRoute: typeof AuthPeopleIdRoute
  AuthPremiumSplatRoute: typeof AuthPremiumSplatRoute
  AuthWalletsWatchedRoute: typeof AuthWalletsWatchedRoute
  AuthContactsIndexRoute: typeof AuthContactsIndexRoute
  AuthDeveloperIndexRoute: typeof AuthDeveloperIndexRoute
  AuthHostsIndexRoute: typeof AuthHostsIndexRoute
  AuthPeopleIndexRoute: typeof AuthPeopleIndexRoute
  AuthWalletsIndexLazyRoute: typeof AuthWalletsIndexLazyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAboutRoute: AuthAboutRoute,
  AuthActivitiesRoute: AuthActivitiesRoute,
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthApiDocsRoute: AuthApiDocsRoute,
  AuthCheckoutRoute: AuthCheckoutRoute,
  AuthCommissionsRoute: AuthCommissionsRouteWithChildren,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthEarnRateRoute: AuthEarnRateRoute,
  AuthHelpRoute: AuthHelpRoute,
  AuthHotspotsRoute: AuthHotspotsRouteWithChildren,
  AuthLegalRoute: AuthLegalRouteWithChildren,
  AuthMonthlyReportRoute: AuthMonthlyReportRoute,
  AuthNewsRoute: AuthNewsRoute,
  AuthNotesRoute: AuthNotesRoute,
  AuthNotificationsRoute: AuthNotificationsRoute,
  AuthPaymentsRoute: AuthPaymentsRoute,
  AuthPayoutsRoute: AuthPayoutsRoute,
  AuthPlansRoute: AuthPlansRoute,
  AuthPremiumRoute: AuthPremiumRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthSettlementsRoute: AuthSettlementsRouteWithChildren,
  AuthSitesRoute: AuthSitesRouteWithChildren,
  AuthSpeedtestRoute: AuthSpeedtestRoute,
  AuthSplitsRoute: AuthSplitsRouteWithChildren,
  AuthSupportRoute: AuthSupportRoute,
  AuthTagsRoute: AuthTagsRouteWithChildren,
  AuthTopSpotsRoute: AuthTopSpotsRoute,
  AuthAccountSubscriptionRoute: AuthAccountSubscriptionRoute,
  AuthCheckoutSuccessRoute: AuthCheckoutSuccessRoute,
  AuthContactsIdRoute: AuthContactsIdRoute,
  AuthDashboardCustomizeRoute: AuthDashboardCustomizeRoute,
  AuthDeveloperApiTokensRoute: AuthDeveloperApiTokensRoute,
  AuthDeveloperWebhooksRoute: AuthDeveloperWebhooksRouteWithChildren,
  AuthHostsIdRoute: AuthHostsIdRoute,
  AuthPeopleIdRoute: AuthPeopleIdRoute,
  AuthPremiumSplatRoute: AuthPremiumSplatRoute,
  AuthWalletsWatchedRoute: AuthWalletsWatchedRoute,
  AuthContactsIndexRoute: AuthContactsIndexRoute,
  AuthDeveloperIndexRoute: AuthDeveloperIndexRoute,
  AuthHostsIndexRoute: AuthHostsIndexRoute,
  AuthPeopleIndexRoute: AuthPeopleIndexRoute,
  AuthWalletsIndexLazyRoute: AuthWalletsIndexLazyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface CitiesRouteChildren {
  CitiesIdRoute: typeof CitiesIdRoute
}

const CitiesRouteChildren: CitiesRouteChildren = {
  CitiesIdRoute: CitiesIdRoute,
}

const CitiesRouteWithChildren =
  CitiesRoute._addFileChildren(CitiesRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AccountRoute: AccountRoute,
  ApiRoute: ApiRoute,
  ApiTokensRoute: ApiTokensRoute,
  CitiesRoute: CitiesRouteWithChildren,
  Dashboard_boxesRoute: Dashboard_boxesRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ImprintRoute: ImprintRoute,
  LoginRoute: LoginRoute,
  NeighborhoodRoute: NeighborhoodRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  ReportingsRoute: ReportingsRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SharesRoute: SharesRoute,
  User_hotspotsRoute: User_hotspotsRoute,
  User_walletsRoute: User_walletsRoute,
  Webhook_eventsRoute: Webhook_eventsRoute,
  WelcomeRoute: WelcomeRoute,
  MapLazyRoute: MapLazyRoute,
  HotspotsIdRoute: HotspotsIdRoute,
  WalletsIdRoute: WalletsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
